module.exports = __webpack_public_path__ + "static/android-icon-192x192-f3c9f43a1ef1fb2a01461c2874babc15.png";